import React from "react";
import ImageModal from "./ImageModal";

export default function SingleAttraction({title = "", children, imagesSources = [], withBottomBorder = true }) {
  return (
      <div className="content-box">
        <h2 id={title}> {title} </h2>
        {children}
        <div className="two-column">
          <div className="row" style={withBottomBorder ? {borderBottom: "solid 1px rgb(204, 204, 204)", marginBottom: "30px"} : {paddingBottom: "0px"}}>
            {imagesSources.map((path, index) => {
              return (
                <div key={index} className="image-column col-md-6">
                  <figure className="image">
                    <ImageModal imagePath={path} />
                  </figure>
                </div>
              );
            })}
          </div>
        </div>
      </div>
  );
}
